export const mockEvents = [
  {
    id: '1',
    title: 'Tech Innovation Summit 2025',
    description: 'Join industry leaders for groundbreaking discussions on AI, blockchain, and the future of technology. Network with innovators and discover emerging trends that will shape our digital future.',
    date: '2025-03-15',
    time: '09:00',
    location: 'San Francisco Convention Center',
    capacity: 500,
    registered: 342,
    price: 299,
    category: 'Technology',
    image: 'https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg',
    organizer: 'TechVision Inc.',
    tags: ['AI', 'Blockchain', 'Innovation', 'Networking'],
    featured: true
  },
  {
    id: '2',
    title: 'Digital Marketing Masterclass',
    description: 'Master the art of digital marketing with hands-on workshops covering SEO, social media, and content strategy from industry experts who have built million-dollar campaigns.',
    date: '2025-02-20',
    time: '10:00',
    location: 'New York Business Center',
    capacity: 200,
    registered: 156,
    price: 149,
    category: 'Marketing',
    image: 'https://images.pexels.com/photos/7688460/pexels-photo-7688460.jpeg',
    organizer: 'Digital Growth Academy',
    tags: ['SEO', 'Social Media', 'Content', 'Strategy'],
    featured: false
  },
  {
    id: '3',
    title: 'Sustainable Business Forum',
    description: 'Explore sustainable business practices and environmental responsibility. Learn from companies leading the green revolution and discover how to build profitable, eco-friendly businesses.',
    date: '2025-04-10',
    time: '08:30',
    location: 'Seattle Green Center',
    capacity: 350,
    registered: 89,
    price: 199,
    category: 'Sustainability',
    image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg',
    organizer: 'EcoFuture Solutions',
    tags: ['Sustainability', 'Environment', 'Green Business', 'CSR'],
    featured: true
  },
  {
    id: '4',
    title: 'Startup Pitch Competition',
    description: 'Watch innovative startups pitch their ideas to top investors. Network with entrepreneurs and discover the next big thing in the startup ecosystem.',
    date: '2025-01-25',
    time: '14:00',
    location: 'Austin Innovation Hub',
    capacity: 400,
    registered: 298,
    price: 79,
    category: 'Startup',
    image: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg',
    organizer: 'Venture Connect',
    tags: ['Startups', 'Pitching', 'Investment', 'Innovation'],
    featured: false
  },
  {
    id: '5',
    title: 'UX/UI Design Workshop',
    description: 'Hands-on workshop covering modern design principles, user research, and prototyping tools. Perfect for designers at all levels looking to elevate their craft.',
    date: '2025-03-05',
    time: '09:30',
    location: 'Los Angeles Design Studio',
    capacity: 150,
    registered: 127,
    price: 179,
    category: 'Design',
    image: 'https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg',
    organizer: 'Design Masters',
    tags: ['UX', 'UI', 'Design Thinking', 'Prototyping'],
    featured: true
  },
  {
    id: '6',
    title: 'Leadership Excellence Conference',
    description: 'Develop exceptional leadership skills with renowned speakers and interactive sessions. Transform your leadership approach and inspire your teams to achieve greatness.',
    date: '2025-02-28',
    time: '11:00',
    location: 'Chicago Leadership Center',
    capacity: 300,
    registered: 201,
    price: 249,
    category: 'Leadership',
    image: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg',
    organizer: 'Executive Excellence',
    tags: ['Leadership', 'Management', 'Team Building', 'Strategy'],
    featured: false
  }
];

export const mockRegistrations = [
  {
    id: 'reg1',
    eventId: '1',
    userId: 'user1',
    registrationDate: '2025-01-10',
    status: 'confirmed',
    ticketNumber: 'TIS2025-001234',
    userName: 'John Smith',
    userEmail: 'john.smith@email.com'
  },
  {
    id: 'reg2',
    eventId: '3',
    userId: 'user1',
    registrationDate: '2025-01-12',
    status: 'confirmed',
    ticketNumber: 'SBF2025-005678',
    userName: 'John Smith',
    userEmail: 'john.smith@email.com'
  }
];